<fn-modal-header class="modal-header">
    <h5 class="modal-title">Search Box</h5>
    <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="closeSearchModal()">
        <span aria-hidden="true">&times;</span>
    </button>
</fn-modal-header>
<mat-dialog-content>
    <div class="row m-0">
        <div class="col-12">
            <div class="search-modal-cmp">
            <div class="search-modal-input">
                <input type="text" [(ngModel)]="searchTerm" (input)="onSearch()" class="form-control radius-40 ng-pristine ng-valid ng-touched" placeholder="Search Menu ID" style="">
                <i class="fn-global-search cyan font-16"></i>
             </div>
            <div class="search-modal-content">
                <ul>
                    <li *ngFor="let item of searchResults" (click)="navigateTo(item)">
                        {{ item.label }}
                    </li>
                </ul>
            </div>
        </div>
        </div>
    </div>
</mat-dialog-content> 